import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as InvoicesAvcActions from './../actions/actions-avc-invoices';

import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as CoreActions from '@uxdf/direct-shared-lib';
import { InvoiceDownloadAPI } from '../../../../../redux/models/invoices/invoice-download-api';
import { AvcInvoicesService } from '../services/avc-invoices.service';
import { State } from './../../../../../redux/reducers/index';
import { InvoiceHierarchyItem } from '../reducers/reducers-avc-invoices';

@Injectable()
export class EffectsAvcInvoices {
  
  getAvcInvoices$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<InvoicesAvcActions.GetAvcInvoices>(InvoicesAvcActions.GET_AVC_INVOICES),
      switchMap((action: any) =>
        this.avcInvoicesService.getAvcInvoicesWithStatus(action.officeId).pipe(
          map((data: InvoiceDownloadAPI.IInvoicesResponsesWithStatus | InvoiceDownloadAPI.IInvoiceResponse[]) => {
            let results;
            if (this.isInvoicesResponsesWithStatus(data)) {
              results = data.searchResponseADDS;
            } else {
              results = data;
            }

            results.sort((a, b) => {
              if (a.creationDate > b.creationDate) {
                return -1;
              }
              if (a.creationDate < b.creationDate) {
                return 1;
              }
              return 0;
            });
            return new InvoicesAvcActions.GetAvcInvoicesSuccess(results, action.officeId);
          }),
          catchError(error => {
            if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
              return of(new CoreActions.DirectUserRoleHasBeenChanged());
            }
            return of(new InvoicesAvcActions.GetAvcInvoicesError('pageSectionIsNotAvailable'));
          })
        )
      ),
      catchError(error => {
        if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
          return of(new CoreActions.DirectUserRoleHasBeenChanged());
        }

        this.store.dispatch(new InvoicesAvcActions.GetAvcInvoicesError(error.message));
        return this.getAvcInvoices$;
      })
    )
  );

  getAvcInvoicesHierarchy$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<InvoicesAvcActions.GetAvcInvoicesHierarchy>(InvoicesAvcActions.GET_AVC_INVOICES_HIERARCHY),
      switchMap(() =>
        this.avcInvoicesService.getAvcInvoicesHierarchy().pipe(
          map((data: InvoiceHierarchyItem[]) => {
            return new InvoicesAvcActions.GetAvcInvoicesHierarchySuccess(data);
          }),
          catchError(() =>  of(new InvoicesAvcActions.GetAvcInvoicesHierarchySuccess([])))
        )
      ),
      catchError(() =>  of(new InvoicesAvcActions.GetAvcInvoicesHierarchySuccess([])))
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<State>,
    private readonly avcInvoicesService: AvcInvoicesService
  ) {}

  private isInvoicesResponsesWithStatus(data: any): data is InvoiceDownloadAPI.IInvoicesResponsesWithStatus {
    return (data as InvoiceDownloadAPI.IInvoicesResponsesWithStatus).searchResponseADDS !== undefined;
  }
}
